import React from 'react';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';

import ActionButton from '../../../../../Elements/ActionButton/ActionButton';

type MaximizeMinimizeScreenProps = {
  isFullScreen: boolean;
  onToggleIsFullScreen: (show?: boolean | null) => void;
};

const MaximizeMinimizeScreen = ({
  isFullScreen,
  onToggleIsFullScreen,
}: MaximizeMinimizeScreenProps) => {
  const label = !isFullScreen ? 'Maximize Screen' : 'Minimize Screen';

  return (
    <React.Fragment>
      <ActionButton
        id={'max_min_screen'}
        onClick={onToggleIsFullScreen}
        icon={
          isFullScreen ? ICONS.open_in_new_down({ className: 'tw-fill-cfo-black' }) : 'open_in_new'
        }
        tooltipSettings={{
          content: label,
          place: 'left',
        }}
      />
    </React.Fragment>
  );
};

export default MaximizeMinimizeScreen;
